import angular from 'angular';

angular.module('cloudX').factory('authInterceptorSvc', [
  '$q',
  '$injector',
  'authService',
  'lockFactory',
  'flySvc',
  function($q, $injector, authService, lockFactory, flySvc) {
    var authInterceptorServiceFactory = {};

    var request = function(config) {
      config.headers = config.headers || {};

      if (
        (!config.url.startsWith('https://') && !config.url.startsWith('http://')) ||
        (config.url.indexOf('adminpulse.') === -1 && config.url.indexOf('//localhost:') === -1)
      ) {
        config.withCredentials = false;
      } else {
        config.headers.Authorization = authService.getAuthorizationHeaderValue();
      }

      return config;
    };

    var responseError = function(rejection) {
      if (
        (rejection.status === 401 || rejection.status === 403) &&
        rejection.config.method != 'HEAD'
      ) {
        flySvc.error('NoPermissionsForThisAction');
      } else if (rejection.status === 550) {
        //Custom status when updating application
        location.reload();
        return undefined;
      }

      return $q.reject(rejection);
    };

    authInterceptorServiceFactory.request = request;
    authInterceptorServiceFactory.responseError = responseError;

    return authInterceptorServiceFactory;
  },
]);
